var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00003 7.05641L4.47136 3.52774C4.34563 3.40631 4.17722 3.33911 4.00243 3.34063C3.82763 3.34215 3.66042 3.41226 3.53682 3.53587C3.41321 3.65947 3.3431 3.82668 3.34158 4.00148C3.34006 4.17627 3.40726 4.34468 3.52869 4.47041L7.05736 7.99908L3.52869 11.5277C3.40726 11.6535 3.34006 11.8219 3.34158 11.9967C3.3431 12.1715 3.41321 12.3387 3.53682 12.4623C3.66042 12.5859 3.82763 12.656 4.00243 12.6575C4.17722 12.659 4.34563 12.5919 4.47136 12.4704L8.00003 8.94174L11.5287 12.4704C11.6544 12.5919 11.8228 12.659 11.9976 12.6575C12.1724 12.656 12.3396 12.5859 12.4632 12.4623C12.5868 12.3387 12.657 12.1715 12.6585 11.9967C12.66 11.8219 12.5928 11.6535 12.4714 11.5277L8.94269 7.99908L12.4714 4.47041C12.535 4.40891 12.5858 4.33535 12.6208 4.25401C12.6557 4.17268 12.6741 4.0852 12.6749 3.99668C12.6756 3.90816 12.6588 3.82037 12.6252 3.73844C12.5917 3.65651 12.5422 3.58208 12.4796 3.51948C12.417 3.45689 12.3426 3.40738 12.2607 3.37386C12.1787 3.34034 12.0909 3.32347 12.0024 3.32424C11.9139 3.32501 11.8264 3.3434 11.7451 3.37834C11.6638 3.41328 11.5902 3.46407 11.5287 3.52774L8.00003 7.05641Z",
    fill: "#42526E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.01e47350.svg";
export { ForwardRef as ReactComponent };